<template>
  <div>this is product search</div>
</template>
<script>
export default {
  name: 'Search'
}
</script>
